/**
 * The HTML tag for the Grid column: 'div' | 'section' | 'form' | 'article' | 'main';
 * @name GridTag
 * @typedef {GridTag}
 * @type {string}
 */
export var GridTag;
(function (GridTag) {
    GridTag["div"] = "div";
    GridTag["section"] = "section";
    GridTag["form"] = "form";
    GridTag["article"] = "article";
    GridTag["main"] = "main";
})(GridTag || (GridTag = {}));
/**
 * Vertical alignment of a grid
 */
export var GridAlignment;
(function (GridAlignment) {
    GridAlignment["start"] = "start";
    GridAlignment["center"] = "center";
    GridAlignment["end"] = "end";
    GridAlignment["stretch"] = "stretch";
})(GridAlignment || (GridAlignment = {}));
